import LockedTicketModal from './LockedTicketModal'

export default LockedTicketModal
